import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Container, TAGTypography, TAGLink, useMediaQuery, Box, Divider } from '../../../..';

var WNResearchFooter = function WNResearchFooter(props) {
  var _data$logo;

  var contentfulData = props.contentfulData;
  var data = contentfulData.footer;
  var brandImageLink = contentfulData.brandImageLink;
  var aboutDataParsed = JSON.parse(data.about.raw);
  var aboutDataContent = aboutDataParsed.content;
  var footerLogo = data.logo.file.url;
  var theme = useTheme();
  var isLargeDevice = useMediaQuery('(min-width: 768px)');

  var footerText = function footerText(content) {
    var contentFields = content.content.map(function (subContent) {
      return subContent;
    });
    return React.createElement(TAGTypography, {
      color: "text.light",
      variant: "bodyMediumBook",
      sx: {
        display: 'flex',
        textAlign: isLargeDevice ? 'unset' : 'center'
      }
    }, contentFields[0].value);
  };

  return React.createElement("footer", {
    style: {
      backgroundColor: theme.palette.backgrounds.dark,
      marginTop: '15px'
    }
  }, React.createElement(Box, {
    sx: {
      padding: '30px 0'
    }
  }, React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    justifyContent: "center",
    alignItems: "center",
    spacing: 3,
    direction: isLargeDevice ? 'row' : 'column'
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 3,
    alignItems: isLargeDevice ? 'flex-start' : 'center',
    justifyContent: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGLink, {
    href: brandImageLink
  }, React.createElement("img", {
    src: footerLogo,
    height: "unset",
    width: "150px",
    alt: ((_data$logo = data.logo) === null || _data$logo === void 0 ? void 0 : _data$logo.description) || ''
  }))), React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    direction: "column"
  }, aboutDataContent.map(function (content, index) {
    return React.createElement(Grid, {
      item: true,
      key: "".concat(content.nodeType, " - ").concat(index)
    }, footerText(content));
  }))), React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: isLargeDevice ? 'flex-start' : 'center',
    justifyContent: "center"
  }, data.socialNetworks.map(function (socialNetwork) {
    var _socialNetwork$image, _socialNetwork$image$;

    return React.createElement(Grid, {
      item: true,
      key: socialNetwork.id
    }, React.createElement(TAGLink, {
      href: socialNetwork.path,
      color: "neutrals.white"
    }, React.createElement("img", {
      src: (_socialNetwork$image = socialNetwork.image) === null || _socialNetwork$image === void 0 ? void 0 : (_socialNetwork$image$ = _socialNetwork$image.file) === null || _socialNetwork$image$ === void 0 ? void 0 : _socialNetwork$image$.url,
      alt: socialNetwork === null || socialNetwork === void 0 ? void 0 : socialNetwork.description
    })));
  }))))), React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Grid, {
    container: true,
    alignItems: isLargeDevice ? 'flex-start' : 'center',
    justifyContent: "space-around",
    spacing: 3,
    direction: isLargeDevice ? 'row' : 'column'
  }, isLargeDevice ? data.navigationGroups.map(function (group, index) {
    return React.createElement(Grid, {
      item: true,
      key: "".concat(index, "-").concat(group.id)
    }, React.createElement(Grid, {
      container: true,
      direction: "column",
      spacing: 2,
      alignItems: isLargeDevice ? 'flex-start' : 'center'
    }, group.navigationLinksForGroup.map(function (navigationItem) {
      return React.createElement(Grid, {
        item: true,
        key: navigationItem.id
      }, React.createElement(TAGLink, {
        href: navigationItem.path,
        color: "text.light",
        variant: "bodyLargeSemiBold",
        underline: "hover"
      }, navigationItem.breadcrumbTitle));
    })));
  }) : React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 2,
    alignItems: 'center'
  }, data.navigationGroups.map(function (group) {
    return group.navigationLinksForGroup.map(function (navigationItem) {
      return React.createElement(Grid, {
        item: true,
        key: navigationItem.id
      }, React.createElement(TAGLink, {
        href: navigationItem.path,
        color: "text.light",
        variant: "bodyLargeSemiBold",
        underline: "hover"
      }, navigationItem.breadcrumbTitle));
    });
  }))))))), React.createElement(Grid, {
    container: true,
    spacing: 3,
    sx: {
      '&.MuiGrid-container': {
        padding: '24px 0'
      }
    }
  }, React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Divider, {
    flexItem: true,
    sx: {
      borderColor: 'text.light'
    }
  }))), React.createElement(Container, null, React.createElement(Grid, {
    container: true,
    justifyContent: "center",
    alignItems: "center",
    spacing: 3
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: "lowestLevel",
    color: "text.light",
    sx: {
      textAlign: 'center',
      justifyContent: 'center',
      display: 'flex'
    }
  }, data.copyright))))));
};

export default WNResearchFooter;